import TasksRoute from './TasksRoute'

function TasksLayout() {
  return <TasksRoute />
}

export default TasksLayout
